<template>
    <div>
        <div class="bg" :style="{
            'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
            'backgroundColor': '#f5f5f5' // 添加备用背景色
        }">
            <div class="logo_wrap ">
                <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
                <div class="logo_right">
                    <div class="power">{{ $t('PoweredbyMVGX') }}</div>
                    <!-- <div class="right_top_txt_shu">|</div>
                    <Kefu :sn="sn"></Kefu> -->
                </div>
            </div>
            <div class="content m_rl_20">
                <div class="content_title">{{ $t('Welcome') }}</div>
                <!-- <span class="content_con">OCBC Public Sector Day</span> -->
                <div class="ban_box">
                    <!-- <el-divider></el-divider> -->
                    <div class="content_con">{{ $t('Yourecalculating') }}</div>
                    <!-- <div class="content_con">Proudly sponsored by</div> -->
                    <!-- <img src="../assets/img/logo_wel.png" alt=""> -->
                </div>

            </div>
            <div class="please">
                <el-row type="flex" :gutter="20" justify="start" class="flex_box">
                    <el-col :span="2">
                        <img src="../assets/img/xuliehao.png" class="xuliehao" alt="">
                    </el-col>
                    <el-col :span="6" class="txt_top">{{ $t('SerialNo') }}:</el-col>
                    <el-col :span="16" class="txt_sn">{{ sn }}</el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row type="flex" :gutter="20" justify="start" class="flex_box">
                    <el-col :span="2">
                        <img src="../assets/img/mima.png" class="mima" alt="">
                    </el-col>
                    <el-col>
                        <el-input v-model="password" maxlength="6" type="password"
                            :placeholder="$t('EnterPassword')"></el-input>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
            </div>
            <div class="m_rl_20">
                <el-button class="btn" @click="submit()">{{$t('Submit')}}</el-button>
            </div>
        </div>

        <el-dialog title="" :visible.sync="centerDialogVisible" :close-on-click-modal="false" width="95%"
            :show-close="false" center>
            <div>{{ message }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_cancel" @click="centerDialogVisible = false">{{ $t('Close') }}</div>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import cnt from "@/api/cnt";
import Kefu from '@/components/kefu.vue'
export default {
    components: { Kefu },
    data() {
        return {
            sn: "",
            Digital: "Digital Life Design 2022",
            World: "World Economic Forum 2022",
            password: '',
            centerDialogVisible: false,
            message: '',
            config: '',
        };
    },
    created() {
        this.sn = this.$route.query.sn;
        cnt.getConfig(res => {
            if (res.code == 200) {
                console.log(123, 'welcome')
                sessionStorage.setItem('configData', JSON.stringify(res.data.configurationVO))
                this.config = res.data.configurationVO || ''
            }
        }, { authType: 1, username: this.sn })
    },
    mounted() {
        this.sn = this.$route.query.sn;
        // this.getUserEvent(1,1)
    },
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        submit() {
            let params = {
                authType: 2,
                username: this.sn,
                password: this.password
            }
            cnt.getLogin(res => {
                if (res.code == 200) {
                    sessionStorage.setItem('user', JSON.stringify(res.data))
                    // this.getUserEvent(2,2)
                    this.$router.push({ path: '/trip', query: { sn: this.sn } })
                } else {
                    this.centerDialogVisible = true
                    this.message = res.message
                }
            }, params)
        },
    },
};
</script>
<style lang="less" scoped>
.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.logo_wrap {
    margin: 1.25rem 1.25rem 2.1875rem;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .logo {
        width: auto;
    }

    .logo_right {
        display: flex;
        align-items: center;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }

    .power {
        font-size: .75rem;
        font-family: Century Gothic;
        color: #EDFFFE;
    }
}




.content {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(0.3125rem);
    padding: 1.875rem 0 1.25rem 0;
    text-align: center;
    color: #fff;
    border-radius: 1.25rem;

    .ban_box {
        padding: 0 42px;

        img {
            margin-top: 14.5px;
            width: 62px;
            height: 62px;
        }
    }
}

.content_title {
    font-size: 1.875rem;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    margin-bottom: 0.625rem;
}

.content_con {
    font-size: 0.9375rem;
    font-family: Century Gothic;
}

.please {
    margin: 31px 0 30px 0;
    padding: 0 20px;
    font-size: 0.9375rem;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #ffffff;

    .el-divider--horizontal {
        margin: 14px 0;
    }
}

.xian {
    display: inline-block;
    width: 2.1875rem;
    height: 0.1875rem;
    background-color: rgba(255, 255, 255, 0.45);
    border-radius: 0.3125rem;
}

.btn {
    width: 100%;
    height: 2.8125rem;
    color: #4d94a0;
    margin-bottom: 1.3125rem;
    border-radius: 0.625rem;
    font-size: 0.9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
}

.el-button+.el-button {
    margin: 0;
}

.btn_world {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(0.3125rem);
    border: 0.0625rem solid #ffffff;
    color: #fff;
}

::v-deep .flex_box {
    display: flex;
    align-items: center;
    margin: 0 !important;

    .el-col {
        padding: 0 !important;

        .el-input__inner {
            background: rgba(0, 0, 0, 0);
            border: 1px solid rgba(220, 223, 230, 0);
            color: #FFFFFF;
            font-size: 15px;
            font-family: Century Gothic;
            padding: 0;

            &::placeholder {
                color: #FFFFFF;
                font-size: 15px;
                font-family: Century Gothic;
            }
        }
    }

    .txt_top {
        font-size: 15px;
        font-family: Century Gothic;
        color: #FFFFFF;
    }
}

.txt_sn {
    text-align: left;
    font-size: 15px;
    font-family: Century Gothic;
    color: #FFFFFF;
}

.xuliehao {
    width: 16.5px;
    height: 14px;
}

.mima {
    width: 14px;
    height: 17px;
}

::v-deep .el-dialog {
    background: #FFFFFF;
    border-radius: 20px;
    margin-top: 30vh !important;

    .el-dialog__title {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303236;
        line-height: 25px;
    }

    .el-dialog__body {
        font-size: 15px;
        font-family: Century Gothic;
        color: #8F8F8F;
        line-height: 20px;
        text-align: center;
        padding: 1.5625rem .875rem 1.875rem !important;
    }

    .dialog-footer {
        display: flex;
        justify-content: center;

        .btn_cancel {
            width: 131px;
            height: 45px;
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            border: 1px solid;
            border-color: linear-gradient(90deg, rgba(107, 179, 201, 1), rgba(90, 198, 153, 1)) 1 1;
            font-size: 15px;
            font-family: Century Gothic;
            color: #4D94A0;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-right: 10px;
        }

        .btn_confirm {
            width: 131px;
            height: 47px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 10px;
        }
    }
}
</style>
